import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/short-msg-management',
            name: 'admin-short-msg-management',
            component: () => import(/* webpackChunkName: "page-admin-mall-management-short-msg-setting" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "短信配置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "微商城管理"
                                        },
                                        {
                                                  name: "短信配置"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
